import { render, staticRenderFns } from "./SelectEmojiPopper.vue?vue&type=template&id=56352912&"
import script from "./SelectEmojiPopper.vue?vue&type=script&lang=js&"
export * from "./SelectEmojiPopper.vue?vue&type=script&lang=js&"
import style0 from "./SelectEmojiPopper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports